import React from 'react';
import styled from 'styled-components/macro';

import { APP_NOTIFICATIONS_DESKTOP_Z_INDEX } from 'web-ui-kit/zIndexes';
import { APP_NOTIFICATIONS_ID } from './constants';

export default function AppNotifications () {
  return (
    <AppNotificationsContainer
      id={APP_NOTIFICATIONS_ID}
    />
  );
}

const AppNotificationsContainer = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  bottom: 0;
  left: 0;
  z-index: ${APP_NOTIFICATIONS_DESKTOP_Z_INDEX};
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
`;
AppNotificationsContainer.displayName = 'AppNotificationsContainer';
